import type { Resource } from '../../';
export const general_close: Resource = {"default":"Close"};
